import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { adaptSugerenciasArray, GET_SUGERENCIAS_MONITOREO } from "../../../data/graphQL/queries/AdminSugerenciasMonitoreo/getSugerencias";

export const useGetRows = (filters, applyClientSideFilters, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const [getSugerencias, { data: dataSugerencias, loading: loadingRows }] = useLazyQuery(GET_SUGERENCIAS_MONITOREO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataSugerencias || loadingRows) return;
    const dataAdapted = adaptSugerenciasArray(dataSugerencias);
    setOriginalData(dataAdapted);

    const dataFilteredFromClientSide = applyClientSideFilters(
      dataAdapted,
      filters.txtFiltro
    );
    setRows(dataFilteredFromClientSide);
    setIsRefetchRequired(false);
  }, [dataSugerencias]);

  const handleSearch = (idDelegacionParam) => {
    const {
      fechaDesde,
      fechaHasta,
      idEstado
    } = filters || {};

    const idDelegacion = filters.idDelegacion || +idDelegacionParam;

    getSugerencias({
      variables: {
        idDelegacion,
        fechaDesde,
        fechaHasta,
        idEstado
      }
    });
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return {
    rows,
    setRows,
    originalData,
    totalCount: rows.length || 0,
    loading: loadingRows,
    handleSearch
  };
};